import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import useUserConfig from '../hooks/useUserConfig';

const UserConfigContext = createContext();

export const UserConfigProvider = ({ children }) => {
  const value = useUserConfig();
  return (
    <UserConfigContext.Provider value={value}>
      {children}
    </UserConfigContext.Provider>
  );
};

UserConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useUserConfigContext = () => useContext(UserConfigContext);
